export const FROM_PARAM = 'seller_landing';
